import { ArslActionAddRow, ArsListingState } from "../interface";

/**
 * Inserts a new body row immediately after the target row.
 *
 * @param state - Current ARS listing state
 * @param action - Add-row action identifying the row after which to insert
 * @returns Updated ARS listing state with the new row inserted
 */
export const arsl_addRow = <T>(
  state: ArsListingState<T>,
  action: ArslActionAddRow,
): ArsListingState<T> => {
  const targetIndex = state.bodyData.arsBodyRows.findIndex((row) => row.id === action.rowId);
  const insertAt = targetIndex + 1;
  const updatedRows = [
    ...state.bodyData.arsBodyRows.slice(0, insertAt),
    {
      id: crypto.randomUUID(),
      rowHeight: 34,
      ellipsis: action.type === "ellipsis",
    },
    ...state.bodyData.arsBodyRows.slice(insertAt),
  ];

  return {
    ...state,
    changed: true,
    bodyData: {
      ...state.bodyData,
      arsBodyRows: updatedRows,
    },
  };
};
